<template lang="pug">
  .text-field.input-field
    input(
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :required="required"
      :class="textType"
      @input="$emit('input', $event.target.value)"
    )
</template>

<style lang="scss" scoped>
.text-field {
  background-color: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
}

label {
  @extend %label-text;
  white-space: nowrap;
}

input {
  height: 48px;
  width: 100%;
  padding-left: 16px;
  @extend %input-text;
  background: rgba(0, 0, 0, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;

  &.secure {
    -webkit-text-security: disc;
    -moz-text-security: disc;
  }

  @include placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>

<script>
export default {
  props: {
    label: { type: String },
    value: { type: String },
    type: { type: String, default: 'text' },
    placeholder: { type: String },
    secure: { type: Boolean, default: false },
    autocomplete: { type: String, default: 'off' },
    required: { type: Boolean, default: true },
  },
  computed: {
    textType() {
      return this.secure ? 'secure' : 'plain'
    },
  },
}
</script>
